import * as React from 'react';

import { FormInput, IFormInputProps } from '../FormInput';

import * as styles from './styles.css';

export interface IFormInputsLayoutProps {
  InputProps: IFormInputProps;
  secondInputProps?: IFormInputProps;
  fullwidth?: boolean;
}

export const FormInputsLayout: React.FC<React.PropsWithChildren<IFormInputsLayoutProps>> = props => {
  const { InputProps, secondInputProps, fullwidth } = props;

  return (
    <div className={styles['container']}>
      <div className={fullwidth ? styles['fullwidth'] : styles['input']}>
        <FormInput autoFocus {...InputProps} />
      </div>
      {secondInputProps && (
        <div className={fullwidth ? styles['fullwidth'] : styles['input']}>
          <FormInput {...secondInputProps} />
        </div>
      )}
    </div>
  );
};

FormInputsLayout.displayName = 'FormInputsLayout';
